import { endpoints, baseurl } from "../Utils/Constants";

export const getAllNotifications = async (token, limit = 20, offset = 0) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_ALL_NOTIFICATIONS}?limit=${limit}&offset=${offset}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching notifications:", error);
        throw error;
    }
};

export const markNotificationsAsRead = async (ids, token) => {
    try {
        const response = await fetch(baseurl + endpoints.MARK_NOTIFICATIONS_READ, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ Ids: ids })
        });
        return await response.json();
    } catch (error) {
        console.error("Error marking notifications as read:", error);
        throw error;
    }
};

export const markNotificationsAsUnread = async (ids, token) => {
    try {
        const response = await fetch(baseurl + endpoints.MARK_NOTIFICATIONS_UNREAD, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ Ids: ids })
        });
        return await response.json();
    } catch (error) {
        console.error("Error marking notifications as unread:", error);
        throw error;
    }
};

export const markAllNotificationsAsRead = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.MARK_ALL_NOTIFICATIONS_READ, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error marking all notifications as read:", error);
        throw error;
    }
};

export const deleteNotifications = async (ids, token) => {
    try {
        const query = ids.map((id) => `ids=${encodeURIComponent(id)}`).join("&");
        const response = await fetch(`${baseurl + endpoints.DELETE_NOTIFICATIONS}?${query}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error deleting notifications:", error);
        throw error;
    }
};
